import { axiosApi } from "./repository"
import { useHistory } from "react-router-dom"

const SetupInterceptors = () => {
  let history = useHistory()
  axiosApi.interceptors.response.use(
    response => {
      return response
    },
    error => {
      if (error?.response?.status === 401) {
        localStorage.removeItem("user")
        localStorage.removeItem("token")
        window.location.href = "/login"
      }
      return Promise.reject(error)
    }
  )
}

export default SetupInterceptors
